// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const browserUnsupportedCss = css`
    #browser-not-support-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: ${getColor("common.ui3")};
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 2147483647;
        > div {
            display: flex;
            flex-direction: column;
            color: ${getColor("text")};
            background: ${getColor("text.inverse")};
            border-radius: 5px;
            padding: 30px 20px;
            max-width: 600px;
            text-align: center;
            position: relative;
            .company-logo {
                max-width: 300px;
                width: 300px;
                margin-bottom: 20px;
                display: inline-block;
                margin: auto;
            }
            .close-button {
                position: absolute;
                background-color: transparent;
                padding: 5px;
                top: 10px;
                right: 10px;
                border: none;
                box-shadow: none;
                cursor: pointer;
                &:hover {
                    color: ${getColor("secondary")};
                }
            }
            .message-title {
                font-weight: bold;
                margin-bottom: 10px;
            }
            .message-body {
                margin-bottom: 20px;
            }
            .supported-browsers {
                display: flex;
                justify-content: center;
                margin-top: 20px;
                .supported-browser {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 30px;
                    margin-bottom: 10px;
                    &:last-child {
                        margin-right: 0;
                    }
                    .browser-logo {
                        position: relative;
                        width: 65px;
                        height: 65px;
                        margin-bottom: 5px;
                    }

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
        a {
            color: ${getColor("primary")};
            &:hover {
                color: ${getColor("secondary")};
            }
            margin-left: 5px;
        }
    }
`;

const browserUnsupportedWarning = () => {
    return {
        __html: `
            if((navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1) && sessionStorage.getItem("notSupportedClosed")!=="true"){
                    var notSupportedDiv = document.createElement("div");
                    notSupportedDiv.setAttribute("id","browser-not-support-container");
                    notSupportedDiv.addEventListener("click",function(event){if(event.target.className==="close-button"){
                    notSupportedDiv.parentNode.removeChild(notSupportedDiv); 
                    sessionStorage.setItem("notSupportedClosed","true")
                }});
                notSupportedDiv.innerHTML = '<div><button class="close-button">&#10006;</button>'+(siteMessages && siteMessages.Browser_UnsupportedWarning) || 'This site does not support your current browser. Please update your browser to the most recent version of Chrome, Edge, Safari or Firefox.'+'</div>';
                document.body.appendChild(notSupportedDiv);
            }
        `,
    };
};

export default browserUnsupportedWarning;
